<template>
    <div>
        <!--展示-->
        <div class="Show">
            <van-nav-bar
                    title="限时特惠"
                    left-text=""
                    left-arrow
                    @click-left="$router.back(-1)"
            />
            <div class="cmain">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="--- 已经到底了 ---"
                    @load="onLoad"
                    >
                    <ul>
                        <li v-for="item in hotList">
                            <router-link :to="{path:'/m/transaction/'+item.id}">
                                <img :src="item.imageUrl"/>
                                <p class="price_name">{{ item.name }}</p>
                                <p class="price_now">
                                    {{ getPriceType(item.priceType).symbol }}{{ item.price }}
                                </p>
                                <p class="price_del"><span v-if="item.originalPrice > item.price">{{ getPriceType(item.priceType).symbol }}{{item.originalPrice}}</span></p>
                            </router-link>
                        </li>
                        <div class="clearb"></div>
                    </ul>
                </van-list>
                <div style="height: 60px"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Special-offer",
        data() {
            return {
                page: 1, 
                pageSize: 10,
                hotList: [],
                loading: false,
                finished: false
            }
        },
        mounted() {
            
        },
        methods: {
            onLoad() {
                var pars = { page: this.page, size: this.pageSize, preferential: true }
                this.$axios.post(window.consts.apis.products, pars).then(r=>{
                    this.loading = false
                    if(r.success){
                        this.hotList = this.hotList.concat(r.result.items)
                        if(this.hotList.length >= r.result.totalCount){
                            this.finished = true
                        } 
                        this.page++
                    }
                })
            }
        }
    }
</script>
